import { render, staticRenderFns } from "./admins-add.vue?vue&type=template&id=cdd20520&scoped=true&"
import script from "./admins-add.vue?vue&type=script&lang=js&"
export * from "./admins-add.vue?vue&type=script&lang=js&"
import style0 from "./admins-add.vue?vue&type=style&index=0&id=cdd20520&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd20520",
  null
  
)

export default component.exports